'use client';

import { PropsWithChildren } from 'react';

import { FeatureToggle } from '@ravago/shared/page-data/models/config';

import { FeatureToggleContext } from '../context/feature-toggle-context';

export const FeatureToggleProvider = ({ featureToggles, children }: { featureToggles: FeatureToggle[] } & PropsWithChildren) => (
   <FeatureToggleContext value={featureToggles}>{children}</FeatureToggleContext>
);
